import React, { useRef, useState } from "react";
import { Box, Typography, Grid, Button, TextField, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { useReactToPrint } from "react-to-print";
import config from "../config/Config";
import axios from "axios";
import { toast } from "react-toastify";
import { apiHeaderToken } from "../helper/My_Helper";
import { useNavigate } from 'react-router-dom';
const GPAForm = ({ candidateData = {}, onUpdate }) => {
  const navigate = useNavigate(); 
  const formRef = useRef();
  const [isAddingNominee, setIsAddingNominee] = useState(false);
  const [isEditingNominee, setIsEditingNominee] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  
  const [nomineeData, setNomineeData] = useState({
    name: "",
    address: ""
  });

  // const appliedJob = candidateData?.applied_jobs?.find(
  //   item => item?.job_id === candidateData?.job_id
  // );
  const appliedJob =
  candidateData?.applied_jobs?.find(
    item => item?.approval_note_data?.note_id  && item?.form_status ==="Offer" || item?.form_status ==="Hired"// priority
  ) ||
  candidateData?.applied_jobs?.find(
    item => item?.job_id === candidateData?.job_id // fallback
  );

  const [nominees, setNominees] = useState(() => {
    if (appliedJob?.nominee_details && Array.isArray(appliedJob?.nominee_details)) {
      return appliedJob?.nominee_details;
    }
    return [];
  });

  const handlePrint = useReactToPrint({
    contentRef: formRef,
    pageStyle: `
      @page {
        size: A4;
        margin: 10mm;
      }

      @media print {
        html, body {
          width: 210mm;
          height: 297mm;
        }

        .no-print {
          display: none !important;
        }

        .footer-section {
          page-break-inside: avoid;
        }

        * {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
      }
    `,
  });

  const getCandidateName = () => {
    const fullName = candidateData?.applicant_form_data?.full_name;

    if (typeof fullName === "object") {
      return [
        fullName?.first_name,
        fullName?.middle_name,
        fullName?.surname,
      ]
        .filter(Boolean)
        .join(" ");
    }

    return (
      candidateData?.name ||
      candidateData?.applicant_form_data?.candidate_name ||
      ""
    );
  };

  const getDesignation = () => {
    return (
      appliedJob?.job_designation ||
      candidateData?.job_title ||
      candidateData?.designation ||
      candidateData?.applied_jobs?.[0]?.job_designation ||
      ""
    );
  };

  const getDateOfBirth = () => {
    const dob = candidateData?.applicant_form_data?.dob;
  
    if (dob?.date && dob?.month && dob?.year) {
      return `${dob.date} ${dob.month} ${dob.year}`;
    }
  
    return candidateData?.date_of_birth || "";
  };

  const getDateOfJoining = () => {
    return (
      candidateData?.annexure_eleven_form_data?.candidate_doj || 
      appliedJob?.onboard_date || 
      candidateData?.applicant_form_data?.date_of_joining ||
      candidateData?.date_of_joining ||
      ""
    );
  };

  const formatDate = (date) => {
    if (!date) return "";

    try {
      const d = new Date(date);
      if (!isNaN(d.getTime())) {
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      }
      return "";
    } catch {
      return "";
    }
  };

  const getCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Handle nominee input changes
  const handleNomineeChange = (e) => {
    setNomineeData({ ...nomineeData, [e.target.name]: e.target.value });
  };

  // Add new nominee
  const handleAddNominee = () => {
    // Validate required fields
    if (!nomineeData.name) {
      toast.error("Nominee name is required");
      return;
    }
    if (!nomineeData.address) {
      toast.error("Nominee address is required");
      return;
    }

    const newNominee = {
      ...nomineeData,
    };

    const updatedNominees = [...nominees, newNominee];
    setNominees(updatedNominees);
    setNomineeData({
      name: "",
      address: ""
    });
    setIsAddingNominee(false);
  };

  // Edit nominee
  const handleEditNominee = (index) => {
    setNomineeData({
      name: nominees[index].name,
      address: nominees[index].address
    });
    setEditIndex(index);
    setIsEditingNominee(true);
  };

  // Update nominee
  const handleUpdateNominee = () => {
    if (!nomineeData.name) {
      toast.error("Nominee name is required");
      return;
    }
    if (!nomineeData.address) {
      toast.error("Nominee address is required");
      return;
    }

    const updatedNominees = [...nominees];
    updatedNominees[editIndex] = { 
      ...nomineeData, 
      id: nominees[editIndex].id 
    };
    setNominees(updatedNominees);
    setNomineeData({
      name: "",
      address: ""
    });
    setIsEditingNominee(false);
    setEditIndex(null);
  };

  // Delete nominee
  const handleDeleteNominee = (index) => {
    const updatedNominees = nominees.filter((_, idx) => idx !== index);
    setNominees(updatedNominees);
  };

  // Cancel edit/add
  const handleCancel = () => {
    setNomineeData({
      name: "",
      address: ""
    });
    setIsAddingNominee(false);
    setIsEditingNominee(false);
    setEditIndex(null);
  };

  // Save all nominees to backend using application/json
  const handleSaveAll = async () => {
    if (nominees.length === 0) {
      toast.error("Please add at least one nominee");
      return;
    }

    setIsSaving(true);
    try {
      const approval_note_doc_id = candidateData?.applied_jobs?.find(
        (item) => item.job_id === candidateData?.job_id
      )?.approval_note_data?.doc_id;

      // if (!approval_note_doc_id) {
      //   toast.error("Please generate the approval note first");
      //   return;
      // }

      // const loginUser = JSON.parse(localStorage.getItem('admin_role_user'));

      // Prepare JSON data
      const jsonData = {
        candidate_doc_id: candidateData._id,
        approval_note_doc_id: appliedJob?.approval_note_data?.doc_id || approval_note_doc_id,
        nominees: nominees,
      };

      const response = await axios.post(
        `${config.API_URL}saveGPADetailsInCandidateProfile`,
        jsonData,
        apiHeaderToken(config.API_TOKEN),
      );

      if (response.status === 200) {
        // toast.success("Nominee details saved successfully");
        localStorage.setItem('successMsg', 'Nominee details Submitted Successfully');
        // Redirect to success page
        navigate('/success');
        if (onUpdate) {
          onUpdate({ nominees: nominees });
        }
      } else {
        toast.error(response.data?.message || "Failed to save nominee details");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "Something went wrong");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box>
      <Box sx={{ textAlign: "center", mb: 2 }} className="no-print">
        <Button
          variant="contained"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
          sx={{ mr: 2 }}
        >
          Print Form
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
          onClick={handleSaveAll}
          disabled={isSaving || nominees.length === 0}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </Box>

      <Box
        ref={formRef}
        sx={{
          backgroundColor: "#fff",
          p: 3,
          fontFamily: "Times New Roman, serif",
          maxWidth: "210mm",
          mx: "auto",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: "relative",
            mb: 3,
            minHeight: "70px",
          }}
        >
          <Box sx={{ position: "absolute", left: 0, top: 0 }}>
            <img
              src={config?.IMAGE_PATH ? config.IMAGE_PATH + "logo512.png" : "/logo512.png"}
              alt="HLFPPT Logo"
              height="55"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/logo512.png";
              }}
            />
          </Box>

          <Typography
            align="center"
            sx={{
              fontSize: "20px",
              fontWeight: "bold",
              letterSpacing: "2px",
              paddingTop: "10px",
              mb: 1,
            }}
          >
            Personal Accident Insurance Nomination Form
          </Typography>
        </Box>

        {/* Employee Details Section */}
        <Box sx={{ mb: 4 }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "bold",
              pb: 0.5,
              mb: 2,
            }}
          >
            Employee Details
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography fontWeight="bold" fontSize="14px">
                Name
              </Typography>
              <Box
                sx={{
                  borderBottom: "1px solid #000",
                  minHeight: "30px",
                  mb: 2,
                }}
              >
                <Typography fontSize="14px">{getCandidateName()}</Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Typography fontWeight="bold" fontSize="14px">
                Designation
              </Typography>
              <Box
                sx={{
                  borderBottom: "1px solid #000",
                  minHeight: "30px",
                  mb: 2,
                }}
              >
                <Typography fontSize="14px">{getDesignation()}</Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Typography fontWeight="bold" fontSize="14px">
                Date of Birth (DD/MM/YYYY)
              </Typography>
              <Box
                sx={{
                  borderBottom: "1px solid #000",
                  minHeight: "30px",
                  mb: 2,
                }}
              >
                <Typography fontSize="14px">
                  {formatDate(getDateOfBirth())}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Typography fontWeight="bold" fontSize="14px">
                Date of Joining
              </Typography>
              <Box
                sx={{
                  borderBottom: "1px solid #000",
                  minHeight: "30px",
                  mb: 2,
                }}
              >
                <Typography fontSize="14px">
                  {formatDate(getDateOfJoining())}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Nominee Details Section */}
        <Box sx={{ mb: 4 }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "bold",
              borderBottom: "2px solid #000",
              pb: 0.5,
              mb: 2,
            }}
          >
            Nominee Details
          </Typography>

          {/* Nominee Table */}
          {nominees.length > 0 && (
            <TableContainer component={Paper} sx={{ mb: 2, border: "1px solid #000" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold", border: "1px solid #000" }}>#</TableCell>
                    <TableCell sx={{ fontWeight: "bold", border: "1px solid #000" }}>Name of Nominee</TableCell>
                    <TableCell sx={{ fontWeight: "bold", border: "1px solid #000" }}>Address</TableCell>
                    <TableCell sx={{ fontWeight: "bold", border: "1px solid #000" }} className="no-print">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {nominees.map((nominee, index) => (
                    <TableRow key={nominee.id || index}>
                      <TableCell sx={{ border: "1px solid #000" }}>{index + 1}</TableCell>
                      <TableCell sx={{ border: "1px solid #000" }}>{nominee.name}</TableCell>
                      <TableCell sx={{ border: "1px solid #000" }}>{nominee.address}</TableCell>
                      <TableCell sx={{ border: "1px solid #000" }} className="no-print">
                        <IconButton size="small" onClick={() => handleEditNominee(index)}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" color="error" onClick={() => handleDeleteNominee(index)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {/* Add/Edit Nominee Form */}
          {(isAddingNominee || isEditingNominee) && (
            <Paper sx={{ p: 2, mb: 2, border: "1px solid #ccc" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nominee Name"
                    name="name"
                    value={nomineeData.name}
                    onChange={handleNomineeChange}
                    size="small"
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nominee Address"
                    name="address"
                    value={nomineeData.address}
                    onChange={handleNomineeChange}
                    size="small"
                    multiline
                    rows={2}
                    required
                  />
                </Grid>
                <Grid item xs={12} sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                  <Button
                    variant="contained"
                    startIcon={isEditingNominee ? <SaveIcon /> : <AddIcon />}
                    onClick={isEditingNominee ? handleUpdateNominee : handleAddNominee}
                    disabled={isSaving}
                  >
                    {isEditingNominee ? "Update" : "Add"} Nominee
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<CancelIcon />}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          )}

          {/* Add Nominee Button */}
          {!isAddingNominee && !isEditingNominee && (
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => setIsAddingNominee(true)}
              className="no-print"
            >
              Add Nominee
            </Button>
          )}
        </Box>

        {/* Footer - Signature Section */}
        <Box className="footer-section" sx={{ mt: 4 }}>
          <Grid container spacing={3}>
          <Grid item xs={6}>
          <Typography fontWeight="bold" fontSize="14px" mb={1}>
            Date
          </Typography>

          <Box
            sx={{
              borderBottom: "1px solid #000",
              minHeight: "30px",
            }}
          >
          <Typography fontSize="14px">
          {appliedJob?.gpa_add_date
            ? new Date(appliedJob.gpa_add_date).toLocaleDateString("en-IN")
            : getCurrentDate()}
        </Typography>
          </Box>
        </Grid>
            <Grid item xs={6}>
              <Typography fontWeight="bold" fontSize="14px" mb={1}>
                Signature of Employee
              </Typography>
              <Box
                sx={{
                  minHeight: "50px",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                {candidateData?.applicant_form_data?.signature && (
                  <img
                    src={`${config?.IMAGE_PATH || ""}${
                      candidateData.applicant_form_data.signature
                    }`}
                    alt="employee-signature"
                    style={{
                      maxHeight: 40,
                      objectFit: "contain",
                    }}
                  />
                )}
              </Box>
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: "12px",
                  fontStyle: "italic",
                }}
              >
                {getCandidateName()}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default GPAForm;